import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Config from "../ConfigHelper";
import Button from "@mui/material/Button";
import ActionRow from "./ActionRow";
import {
  withinHourInterval,
  withinDayInterval,
  shouldAppear,
} from "./DisplayFilters";

import {
  useQuery,
  useQueryClient,
  QueryClient,
  QueryClientProvider,
} from "react-query";

import Moment from "moment";
import { AlternateEmailTwoTone } from "@mui/icons-material";
const API_URL = Config.getApiURL();

const queryClient = new QueryClient();

// stylesw

// display rules

// filters

const DONE_MSG = [
  "Nice job",
  "Crushing it",
  "Way to go",
  "You da man",
  "That's how we do it",
];

const POINTS = ["2", "5", "10", "100", "1000"];

function getPoints() {
  return POINTS[Math.floor(Math.random() * POINTS.length)];
}

function cardStyles() {
  return {
    ondeck: {
      borderLeft: "8px solid orange",
      //color: "#fff",
      // background:
      //   //"radial-gradient(circle,  0%, rgba(252,70,107,1) 100%)",
      //   "linear-gradient(333deg, rgba(131,58,180,1) 0%, rgba(253,29,29,1) 50%, rgba(63,94,251,1) 100%)",
    },
    overdue: {
      borderLeft: "8px solid red",
      // color: "rgba(255, 255, 255, 0.9)",
      // background:
      //   "linear-gradient(333deg, rgba(131,58,180,1) 0%, rgba(253,29,29,1) 50%, rgba(252,176,69,1) 100%)",
      padding: 0,
      "&:last-child": {
        paddingBottom: 0,
      },
    },
    ok: {
      borderLeft: "8px solid green",
      // color: "rgba(0, 0, 0, 0.7)",
      // background:
      //   "radial-gradient(circle, rgba(28,172,120,1) 44%, rgba(39,101,78,1) 81%);",
    },
  };
}

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "rgb(10, 10, 10, 0.1)",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const List = (props) => {
  const [show, setShow] = useState(true);

  function startTimer(action) {
    props.setCurrentAction(action);
    props.setTimerActive(true);
    setShow(false);
  }

  function handleFilter(val) {
    props.setFilter(val);
    props.setDomains("work");
  }

  function wasRecentlyCompleted(action_id) {
    let arr = props.done.filter((v) => v.id === action_id);
    if (arr.length === 0) return false;

    let completed_at = arr[0].time;

    const time = new Date();
    time.setSeconds(time.getSeconds() + 10);
    return completed_at < time;
  }

  function isCompleted(action_id) {
    return props.done.filter((v) => v.id === action_id).length > 0;
  }

  Moment.locale("en");

  if (!props.loaded) return "Loading...";

  return (
    <div>
      <Grid container>
        <Grid item>
          <h3>
            <Button onClick={() => setShow((prev) => !prev)}>
              {props.heading}
            </Button>
          </h3>
        </Grid>
      </Grid>
      {show && (
        <Grid container spacing={1}>
          {props.actions.filter(props.filterFunc).map((action) => {
            return (
              <ActionRow
                action={action}
                visible={shouldAppear(
                  action.label,
                  action.days_array,
                  action.startHour,
                  action.endHour,
                  action.dueToday
                )}
                done={props.done}
                setDone={props.setDone}
                completed={
                  !wasRecentlyCompleted(action.id) && isCompleted(action.id)
                }
                recentlyCompleted={wasRecentlyCompleted(action.id)}
                showTimeDue={["hour", "daily"].includes(action.scheduleType)}
                setCelebrate={props.setCelebrate}
                showIcon={!props.compact}
                showTime={!props.compact}
                showTags={!props.compact}
                showLink={!props.compact}
                setCurrentAction={props.setCurrentAction}
                showTimer={!props.compact}
                wallDisplay={props.compact}
                handleTimer={startTimer}
                {...props}
              />
            );
          })}
        </Grid>
      )}
    </div>
  );
};
export default List;
